import { Component, inject, signal, ViewChild } from '@angular/core';
import { Popover } from 'primeng/popover';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AccountDeletionDialogComponent } from './delete-popover/delete-popover.component';

interface MenuSection {
  label: string;
  icon: string;
  routeFn?: () => string[];
}

@Component({
  selector: 'pa-menu-popover',
  imports: [CommonModule, PopoverModule ,AccountDeletionDialogComponent],
  templateUrl: './menu-popover.component.html',
  styles: [`
    :host {
      display: contents;
    }

    ::ng-deep {
      @media (max-width: 768px) {
        .pra-menu-popover {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          max-width: 100vw !important;
          max-height: 100vh !important;
          margin: 0 !important;
          border-radius: 0 !important;
        }

        .pra-menu-popover .p-popover-content {
          width: 100% !important;
          height: 100% !important;
          border-radius: 0 !important;
          overflow-y: auto !important;
        }
      }

      @media (min-width: 769px) {
        .pra-menu-popover {
          width: 480px !important;
        }
      }
    }
  `]
})
export class MenuPopoverComponent {
  @ViewChild('menuPopover') menuPopover!: Popover;
  @ViewChild('helpPopover') helpPopover!: Popover;
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);
  readonly DeletePopupVisible = signal<boolean>(false);
  menuSections = {
    aboutYou: [
      {
        label: 'Profile',
        icon: 'assets/icons/fill-icons/profile.png',
        routeFn: () => ['/contacts', this.auth.getUser()?.user_id ?? '']
      },
      {
        label: 'Contact List',
        icon: 'assets/icons/fill-icons/contacts.svg',
        routeFn: () => ['/contacts']
      },
      { label: 'Payment Method', icon: 'assets/icons/payout-icon.svg', routeFn: () => ['/payments'] },
      {
        label: 'File Center',
        icon: 'assets/icons/fill-icons/filecenter.png',
        routeFn: () => ['/file-center']
      },
      { label: 'Account Deletion', icon: 'assets/icons/fill-icons/accountdeletion.png', }

    ],
    // portfolio: [
    //   { label: 'Vehicle List', icon: 'assets/icons/fill-icons/vehiclelist.png' },
    //   { label: 'Property List', icon: 'assets/icons/fill-icons/propertylist.png' }
    // ],
    others: [
      // { label: 'System Info X.X', icon: 'assets/icons/fill-icons/system.png' },
      { label: 'Help', icon: 'assets/icons/fill-icons/help.png' },
      { label: 'Terms', icon: 'assets/icons/fill-icons/terms.png', routeFn: () => ['/terms'] },
      { label: 'Privacy', icon: 'assets/icons/fill-icons/aboutus.png', routeFn: () => ['/privacy'] }
    ]
  };

  onMenuItemClick(item: MenuSection): void {
    this.menuPopover.hide();
    if (item.routeFn) {
      this.router.navigate(item.routeFn());
    }
    if (item.label === 'Account Deletion') {
      this.DeletePopupVisible.set(true);
    }
  }

  contactSupport(): void {
    window.location.href = 'mailto:info@goprimeaccess.com';
    this.helpPopover?.hide();
    this.menuPopover?.hide();
  }
}
